// TODO @BalajiSriraman - Need to test this component before fixing
'use client'

import { type ReactNode, useEffect, useState } from 'react'
import type { PostHog } from 'posthog-js'

type PostHogProviderComponent
  = typeof import('posthog-js/react').PostHogProvider

type PHProviderProps = {
  children: ReactNode
}

export default function PHProvider({ children }: PHProviderProps) {
  const [PostHogProvider, setPostHogProvider]
    = useState<PostHogProviderComponent | null>(null)
  const [posthog, setPosthog] = useState<PostHog | null>(null)

  useEffect(() => {
    // PostHog is initialized once in instrumentation-client.ts. This provider
    // only exposes that singleton to React hooks when analytics is configured.
    if (
      typeof window !== 'undefined'
      && process.env.NEXT_PUBLIC_POSTHOG_KEY
    ) {
      Promise.all([import('posthog-js'), import('posthog-js/react')]).then(
        ([posthogModule, reactModule]) => {
          const posthog = posthogModule.default
          const { PostHogProvider } = reactModule

          setPosthog(posthog)
          setPostHogProvider(() => PostHogProvider)
        },
      )
    }
  }, [])

  // If PostHog isn't loaded yet or we're on the server, just return children
  if (!PostHogProvider || !posthog || typeof window === 'undefined') {
    return <>{children}</>
  }

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}
